import { create } from 'zustand';
import type { CourseSlice } from './courseSlice';
import type { SettingsSlice } from './settingsSlice';
import type { ResultsSlice } from './resultsSlice';
import type { UISlice } from './uiSlice';
import type { ContextSlice } from './contextSlice';
import type { ScenarioSlice } from './scenarioSlice';
import type { ShortlistSlice } from './shortlistSlice';
import { createCourseSlice } from './courseSlice';
import { createSettingsSlice } from './settingsSlice';
import { createResultsSlice } from './resultsSlice';
import { createUISlice } from './uiSlice';
import { createContextSlice } from './contextSlice';
import { createScenarioSlice } from './scenarioSlice';
import { createShortlistSlice } from './shortlistSlice';
import { calculateEverything } from '@gpa-scales/shared-logic';

export type AppStore = CourseSlice & SettingsSlice & ResultsSlice & UISlice & ContextSlice & ScenarioSlice & ShortlistSlice;

export const useAppStore = create<AppStore>()((...a) => {
  const store = {
    ...createCourseSlice(...a),
    ...createSettingsSlice(...a),
    ...createResultsSlice(...a),
    ...createUISlice(...a),
    ...createContextSlice(...a),
    ...createScenarioSlice(...a),
    ...createShortlistSlice(...a),
  };

  return store;
});

// Recalculation function — reads current state and computes
export function recalculateStore() {
  const state = useAppStore.getState();
  try {
    const result = calculateEverything(state.courses, state.settings);
    useAppStore.setState({ result });
  } catch (e) {
    console.error('Recalculation failed:', e);
  }
}
